// Open a URL outside the SPA: the in-app system browser on native (the bundled
// WebView can't navigate away from the app to a server route), a new tab on web.
function openExternal(url: string) {
    const cap = (window as any).Capacitor
    if (cap?.isNativePlatform?.()) {
        cap.Plugins?.Browser?.open({ url })
        return
    }
    window.open(url, '_blank')
}

export default { openExternal }
